var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.198 310.169L44.0486 369.318L90.6822 415.951L149.831 356.802C131.051 344.904 115.096 328.949 103.198 310.169Z",
    fill: "url(#paint0_linear_2_26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.951 90.6822L369.318 44.0486L310.169 103.198C328.949 115.096 344.904 131.051 356.802 149.831L415.951 90.6822Z",
    fill: "url(#paint1_linear_2_26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.169 356.802L369.318 415.951L415.951 369.318L356.802 310.169C344.904 328.949 328.949 344.904 310.169 356.802Z",
    fill: "url(#paint2_linear_2_26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6822 44.0486L44.0486 90.6822L103.198 149.831C115.096 131.051 131.051 115.096 149.831 103.198L90.6822 44.0486Z",
    fill: "url(#paint3_linear_2_26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.364 262.975C378.744 252.364 380 241.329 380 230C380 218.671 378.744 207.636 376.364 197.025L460 197.025V262.975H376.364Z",
    fill: "url(#paint4_linear_2_26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6361 197.025L0 197.025V262.975H83.6361C81.2559 252.364 80 241.329 80 230C80 218.671 81.2559 207.636 83.6361 197.025Z",
    fill: "url(#paint5_linear_2_26)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.025 376.364V460H262.975V376.364C252.364 378.744 241.329 380 230 380C218.671 380 207.636 378.744 197.025 376.364Z",
    fill: "url(#paint6_linear_2_26)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.975 0H197.025V83.6361C207.636 81.2559 218.671 80 230 80C241.329 80 252.364 81.2559 262.975 83.6361V0Z",
    fill: "url(#paint7_linear_2_26)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 230.5,
    r: 177.5,
    stroke: "#252525",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.31 375.899C301.604 397.4 264.881 408.627 227.402 407.973C189.924 407.319 153.614 394.816 123.678 372.258C93.7415 349.699 71.7153 318.242 60.7559 282.396C49.7966 246.55 50.4668 208.154 62.6705 172.712",
    stroke: "#FFCB00",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.095 22.179C100.818 22.5131 99.5367 23.1882 98.3969 24.1273C97.257 25.0664 96.3048 26.2316 95.6487 27.4901L83.3893 50.8547L59.9606 48.1245C58.8553 48.0085 57.6308 48.2174 56.4118 48.7298C55.1928 49.2422 54.0229 50.0399 53.0212 51.0416C52.0195 52.0433 51.2219 53.2132 50.7094 54.4322C50.197 55.6512 49.9882 56.8757 50.1042 57.9809L52.8343 81.4096L29.4697 93.6691C28.2097 94.3275 27.043 95.281 26.1014 96.4217C25.1598 97.5624 24.4808 98.8448 24.1413 100.124C23.8018 101.403 23.8153 102.628 24.1802 103.66C24.5451 104.692 25.2469 105.491 26.2063 105.965L61.8739 123.75C62.5623 124.096 63.3691 124.265 64.2453 124.246C65.1215 124.226 66.0489 124.02 66.9713 123.638C68.2249 123.125 69.4306 122.312 70.4607 121.283C70.9603 120.782 71.4081 120.235 71.7911 119.657C84.9299 100.2 102.145 82.9854 121.601 69.8466C123.364 68.6328 124.795 66.8994 125.582 65.0269C125.971 64.1039 126.182 63.1744 126.202 62.2971C126.221 61.4197 126.048 60.6136 125.694 59.9295L107.944 24.2266C107.467 23.2698 106.667 22.571 105.633 22.2091C104.599 21.8473 103.374 21.8369 102.095 22.179Z",
    fill: "#FFCB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2_26",
    x: 33,
    y: 152.709,
    width: 319.311,
    height: 275.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2_26",
    x: 13.8962,
    y: 11.9299,
    width: 122.307,
    height: 122.317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2_26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_26",
    x1: 146.06,
    y1: 313.94,
    x2: 67.3654,
    y2: 392.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_26",
    x1: 392.635,
    y1: 67.3654,
    x2: 313.94,
    y2: 146.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_26",
    x1: 313.94,
    y1: 313.94,
    x2: 392.635,
    y2: 392.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_26",
    x1: 67.3654,
    y1: 67.3654,
    x2: 146.06,
    y2: 146.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_26",
    x1: 348.71,
    y1: 230,
    x2: 460,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_26",
    x1: 0,
    y1: 230,
    x2: 111.29,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_26",
    x1: 230,
    y1: 348.71,
    x2: 230,
    y2: 460,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_26",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 111.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlace);
export default __webpack_public_path__ + "static/media/firstPlace.ac7243bc8bfe43b28a47367cf15d974b.svg";
export { ForwardRef as ReactComponent };